import React, { useEffect } from 'react'
import { GeoapifyGeocoderAutocomplete, GeoapifyContext } from '@geoapify/react-geocoder-autocomplete'
import '@geoapify/geocoder-autocomplete/styles/minimal.css'
import { geoapifyApiKey } from 'constants/locationCode.constants'

const GeocoderAutocomplete = (props) => {
  const geoCoderInputClass = '.geoapify-autocomplete-input'

  useEffect(() => {
    // Wait for the component to mount and then find the input element
    const intervalId = setInterval(() => {
      const inputElement = document.querySelector(geoCoderInputClass)
      if (inputElement) {
        inputElement.setAttribute('autocomplete', 'street-line1')
        clearInterval(intervalId)
      }
    }, 100)

    return () => clearInterval(intervalId)
  }, [])

  return (
    <GeoapifyContext apiKey={geoapifyApiKey}>
      <GeoapifyGeocoderAutocomplete {...props} />
    </GeoapifyContext>
  )
}

export default GeocoderAutocomplete
